import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createActionRewardConfig, updateActionRewardConfig } from '~/services/LoyaltyService';

import type {
  CreateActionRewardConfigRequestBody,
  CreateActionRewardConfigResponse,
  UpdateActionRewardConfigRequestBody,
  UpdateActionRewardConfigResponse,
} from '~/types/loyaltyContract';

import { actionRewardConfigQueryKeys } from './actionRewardConfigQueryKeys';

interface MutationOptions<TData> {
  onSuccess?: (data: TData) => void;
  onError?: (error: Error) => void;
}

/** Create an action reward config. */
export function useCreateActionRewardConfig(options: MutationOptions<CreateActionRewardConfigResponse> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateActionRewardConfigRequestBody) => createActionRewardConfig(body),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: actionRewardConfigQueryKeys.list() });
      options.onSuccess?.(data);
    },
    onError: options.onError,
  });
}

/** Update an action reward config by id. */
export function useUpdateActionRewardConfig(options: MutationOptions<UpdateActionRewardConfigResponse> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateActionRewardConfigRequestBody }) =>
      updateActionRewardConfig(id, body),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: actionRewardConfigQueryKeys.list() });
      options.onSuccess?.(data);
    },
    onError: options.onError,
  });
}
